import React from 'react'
import styled from 'styled-components'
import { BridalPlanProps } from '../../../../BridalPlan.types'
import { Badge } from '../../../../../../components/ui-elements/Badge'
import { styleTheme } from '../../../../../../style/theme'
import { getPrimaryColor, getPrimaryColorOpacity10 } from '../../../../../../style/utils'

type PriceProps = {
  className?: string
  plan: BridalPlanProps | undefined
  theme?: any
  primaryColor?: string
}

export const Price = (props: PriceProps) => {
  return <StyledComponent {...props} />
}

const Component: React.FC<PriceProps> = ({ plan, className, primaryColor }) => {
  return (
    <>
      <h2>プラン料金と概要</h2>
      <div className={className}>
        {!!plan?.baseDiscount && (
          <Badge
            children={<span>{Number(plan?.baseDiscount).toLocaleString()}円割引</span>}
            primaryColor={primaryColor}
          />
        )}
        {(() => {
          switch (plan?.displayType) {
            case 'fixed_people':
              return (
                <>
                  <div className={`${className}__primary-text`}>
                    {!!plan?.targetNumberOfGuests && (
                      <span className={`${className}__primary-text-prefix`}>
                        {plan?.targetNumberOfGuests.toLocaleString()}名様の場合
                      </span>
                    )}
                    {!!plan?.basePrice && (
                      <span className={`${className}__primary-text-main`}>
                        <span>{(plan?.basePrice - (plan?.baseDiscount || 0)).toLocaleString()}</span>円
                      </span>
                    )}
                    {!!plan?.basePrice && !!plan?.baseDiscount && (
                      <span className={`${className}__primary-text-suffix`}>
                        (<span className="cancel">{Number(plan?.basePrice).toLocaleString()}円</span>)
                      </span>
                    )}
                  </div>
                  <div className={`${className}__secondary-text`}>
                    {!!plan?.pricePerAdditionalGuest && (
                      <span className={`${className}__secondary-text-main`}>
                        お一人様追加料金
                        <span>{(plan?.pricePerAdditionalGuest - (plan?.discountPerGuest || 0)).toLocaleString()}</span>
                        円
                      </span>
                    )}
                    {!!plan?.pricePerAdditionalGuest && !!plan?.discountPerGuest && (
                      <span>
                        <span className={`${className}__secondary-text-cancel`}>
                          {Number(plan?.pricePerAdditionalGuest).toLocaleString()}円
                        </span>
                      </span>
                    )}
                  </div>
                </>
              )
            case 'basic':
              return (
                <>
                  <div className={`${className}__primary-text`}>
                    <span className={`${className}__primary-text-prefix`}>基本料金</span>
                    {!!plan?.basePrice && (
                      <span className={`${className}__primary-text-main`}>
                        <span>{(plan?.basePrice - (plan?.baseDiscount || 0)).toLocaleString()}</span>円
                      </span>
                    )}
                    {!!plan?.basePrice && !!plan?.baseDiscount && (
                      <span className={`${className}__primary-text-suffix`}>
                        (<span className="cancel">{Number(plan?.basePrice).toLocaleString()}円</span>)
                      </span>
                    )}
                  </div>
                  <div className={`${className}__primary-text`}>＋</div>
                  <div className={`${className}__primary-text`}>
                    <span className={`${className}__primary-text-prefix`}>人数×</span>
                    {!!plan?.pricePerAdditionalGuest && (
                      <span className={`${className}__primary-text-main`}>
                        <span>{(plan?.pricePerAdditionalGuest - (plan?.discountPerGuest || 0)).toLocaleString()}</span>
                        円
                      </span>
                    )}
                    {!!plan?.pricePerAdditionalGuest && !!plan?.discountPerGuest && (
                      <span className={`${className}__primary-text-suffix`}>
                        (<span>{Number(plan?.pricePerAdditionalGuest).toLocaleString()}円</span>)
                      </span>
                    )}
                  </div>
                </>
              )
            case 'fixed_price':
              return (
                <>
                  <div className={`${className}__primary-text`}>
                    <span className={`${className}__primary-text-prefix`}>固定料金</span>
                    {!!plan?.basePrice && (
                      <span className={`${className}__primary-text-main`}>
                        <span>{(plan?.basePrice - (plan?.baseDiscount || 0)).toLocaleString()}</span>円
                      </span>
                    )}
                    {!!plan?.basePrice && !!plan?.baseDiscount && (
                      <span className={`${className}__primary-text-suffix`}>
                        (<span className="cancel">{Number(plan?.basePrice).toLocaleString()}円</span>)
                      </span>
                    )}
                  </div>
                  <div className={`${className}__secondary-text`}>
                    {(!!plan?.minNumberOfGuests || !!plan?.maxNumberOfGuests) && (
                      <span className={`${className}__secondary-text-main`}>
                        {plan?.minNumberOfGuests}〜{plan?.maxNumberOfGuests}名
                      </span>
                    )}
                  </div>
                </>
              )
          }
        })()}
      </div>
    </>
  )
}

const StyledComponent = styled(Component)`
  background-color: ${getPrimaryColorOpacity10};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 18px;

  &__primary-text {
    color: ${getPrimaryColor};
    line-height: 1.5;
    display: flex;
    justify-content: center;
    align-items: baseline;
    flex-wrap: wrap;

    &-prefix {
      font-weight: bold;
      margin-right: 12px;
    }

    &-main {
      font-weight: bold;

      > span {
        font-size: 32px;
      }
    }

    &-suffix {
      margin-left: 4px;

      > span {
        text-decoration: line-through;
      }
    }
  }

  &__secondary-text {
    color: ${styleTheme.colors.black};
    line-height: 1.5;
    font-size: 14px;

    &-main {
      font-weight: bold;

      > span {
        margin-left: 4px;
      }
    }

    &-cancel {
      text-decoration: line-through;
      margin-left: 4px;
    }
  }
`
